import classNames from "classnames";

// Components
import { ButtonVariationType } from "../Button";

import "./styles.sass";

type SpinProps = {
  size: "s" | "xl";
  variation?: ButtonVariationType;
};

const Spin = (props: SpinProps) => {
  const { size = "s", variation = "primary" } = props;

  const SpinClass = classNames("Spin", {
    [`Spin__${variation}`]: !!variation,
    [`Spin__${size}`]: !!size,
  });
  return (
    <div className={SpinClass}>
      <div className="Spin__item Spin__item-1" />
      <div className="Spin__item Spin__item-2" />
      <div className="Spin__item Spin__item-3" />
      <div className="Spin__item Spin__item-4" />
      <div className="Spin__item Spin__item-5" />
      <div className="Spin__item Spin__item-6" />
      <div className="Spin__item Spin__item-7" />
      <div className="Spin__item Spin__item-8" />
      <div className="Spin__item Spin__item-9" />
      <div className="Spin__item Spin__item-10" />
      <div className="Spin__item Spin__item-11" />
      <div className="Spin__item Spin__item-12" />
    </div>
  );
};

export default Spin;
